import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AdminLayoutComponent } from './core/containers/admin-layout/admin-layout.component';
import { LoginComponent } from './core/containers/login/login.component';
import { PageNotFoundComponent } from './core/containers/page-not-found/page-not-found.component';
import { AuthGuard } from './core/guards/auth.guard';
import { IsAdminGuard } from './core/guards/is-admin.guard';
import { EntitiesAllowedRolesGuard } from './core/guards/entities-allowed-roles.guard';
import { StoreTokenComponent } from './core/containers/store-token/store-token.component';

const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'users',
        pathMatch: 'full',
      },
      {
        path: 'users',
        loadChildren: './users/users.module#UsersModule',
        canActivate: [AuthGuard, IsAdminGuard],
      },
      {
        path: 'entities',
        loadChildren: './entities/entities.module#EntitiesModule',
        canActivate: [AuthGuard, EntitiesAllowedRolesGuard],
      },
      {
        path: 'cases',
        loadChildren: './cases/cases.module#CasesModule',
        canActivate: [AuthGuard, IsAdminGuard],
      },
      {
        path: 'documents',
        loadChildren: './documents/documents.module#DocumentsModule',
        canActivate: [AuthGuard, IsAdminGuard],
      },
      {
        path: 'reviews',
        loadChildren: './reviews/reviews.module#ReviewsModule',
        canActivate: [AuthGuard],
      },
      {
        path: 'statistics',
        loadChildren: './statistics/statistics.module#StatisticsModule',
        canActivate: [AuthGuard, IsAdminGuard],
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'store-token',
    component: StoreTokenComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
